import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactMarkdown from 'components/Markdown/Markdown'
import {
  select,
  subSelect,
  reorderField,
  addFieldAbove,
  addFieldUnder,
  addOptionSubfield,
  addCheckSubfield,
  addRepeaterSubfield
} from './DesignerActions'
import {
  DummyTextField,
  DummyRadio,
  DummyCheckbox,
  DummyAddressBlock,
  DummyFileUpload,
  DummyConfirmFields,
  DummyServerSearch,
  DummyDependent,
  DumbRepeater,
  DummyRegisteredAgent,
  Summary,
  DummyFullName,
  DummyNameOrg,
  DummyNameQualifiedOrg,
  DummyUploadAndSubmit,
  DummySearchControl,
  DummySignatures,
  DummyFormationLocale,
  DummyEntityName,
  DummySelectField,
  DummyDateRange,
  DummyDataTable,
  DummyUCCSearch,
  DummyAltUCCSearch,
  DummyDateInput,
  DummyTimeInput,
  DummyMultiComplete,
  DummyEFSPicker,
  DummyLocalSelect
} from './DummyInputs'
import InvisibleIcon from '@tecuity/sos-icons/react/invisible'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import LinkIcon from '@tecuity/sos-icons/react/link'
import LogicSolidIcon from '@tecuity/sos-icons/react/logic-solid'
import { LogIcon, getLogSeverity } from './AuditPanel'
import { useDragStore } from 'components/DragAndDrop/DragContext'
import Droppable from 'components/DragAndDrop/Droppable'
import Pieces from './PieceConfig'

class Field extends Component {
  selectField = () => {
    if (!this.props.onSelect) {
      this.props.select({ type: 'FIELD', id: this.props.fieldId })
    } else {
      this.props.onSelect({ type: 'FIELD', id: this.props.fieldId })
    }
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.selectField()
    }
  }
  getFieldType = () => {
    const { value: originalValue, defaultValue = '' } = this.props
    const value = defaultValue !== '' ? defaultValue : originalValue
    switch (this.props.type) {
      case 'text':
      case 'number':
        return <DummyTextField {...this.props} value={value} />
      case 'textArea':
        return <DummyTextField {...this.props} height={this.props.rows * 20} />
      case 'select':
        const selectedOption = this.props.options.find(option => option.value == value)
        return (
          <DummySelectField
            {...this.props}
            value=""
            label={selectedOption ? selectedOption.label : ''}
          />
        )
      case 'serverSelect': {
        let option =
          this.props.value.toString() !== '0'
            ? this.props.options.find(option => option.value.toString() === value.toString())
            : this.props.placeholder
        let selectedLabel =
          option === this.props.placeholder ? option : option ? option.label : 'Loading...'
        return (
          <div
            style={{ width: this.props.width }}
            className={'text select' + (this.props.disabled ? ' disabled' : '')}
          >
            {selectedLabel}
          </div>
        )
      }
      case 'radio':
      case 'serverRadio':
        return <DummyRadio {...this.props} />
      case 'checkbox':
        return <DummyCheckbox {...this.props} />
      case 'date':
        return <DummyDateInput {...this.props} />
      case 'DateRange':
        return <DummyDateRange {...this.props} />
      case 'addressBlock':
        return <DummyAddressBlock {...this.props} value={value} />
      case 'file':
        return <DummyFileUpload {...this.props} />
      case 'confirmFields':
        return (
          <DummyConfirmFields
            {...this.props}
            firstLabel={this.props.label}
            secondLabel={
              this.props.confirmFieldLabel === ''
                ? 'Confirm ' + this.props.label
                : this.props.confirmFieldLabel
            }
          />
        )
      case 'serverSearch':
        return <DummyServerSearch searchParams={this.props.searchParams} value={this.props.value} />
      case 'DataTable':
        return <DummyDataTable {...this.props} />
      case 'dependentSelect': {
        let selectedOption = this.props.options.find(option => option.value === value)
        let selectedLabel = selectedOption ? selectedOption.label : '[Select an Option]'
        return (
          <DummyDependent {...this.props} fields={this.props.options[0].fields}>
            <div
              style={{ width: this.props.width }}
              className={'text select' + (this.props.disabled === true ? ' disabled' : '')}
            >
              {selectedLabel}
            </div>
          </DummyDependent>
        )
      }
      case 'dependentRadio':
        return (
          <DummyDependent {...this.props} fields={this.props.options[0].fields}>
            <DummyRadio options={this.props.options} disabled={this.props.disabled} />
          </DummyDependent>
        )
      case 'dependentCheck':
        return (
          <DummyDependent
            {...this.props}
            fields={this.props.value ? this.props.checkedFields : this.props.uncheckedFields}
          >
            <DummyCheckbox
              label={this.props.label}
              checked={this.props.value}
              disabled={this.props.disabled}
            />
          </DummyDependent>
        )
      case 'paragraph':
        return this.props.displayType === 'input' ? (
          <DummyTextField
            {...this.props}
            className={`dummy-text-field ${this.props.scrollable ? 'scrollable-paragraph' : ''}`}
            style={{
              height: 'auto',
              maxHeight: this.props.scrollable ? `${this.props.maxHeight}px` : ''
            }}
            disabled
          />
        ) : (
            <ReactMarkdown
              className={`dummy-paragraph markdown ${
                this.props.scrollable ? 'scrollable-paragraph' : ''
                }`}
              style={{
                textAlign: this.props.textAlign,
                width: this.props.width,
                maxHeight: this.props.scrollable ? `${this.props.maxHeight}px` : ''
              }}
              source={this.props.value}
            />
          )
      case 'repeater':
        return <DumbRepeater {...this.props} />
      case 'nameSearch':
        return (
          <DummyConfirmFields
            {...this.props}
            firstLabel={this.props.label}
            secondLabel={'Confirm ' + this.props.label}
            value={this.props.value}
          />
        )
      case 'registeredAgentSearch':
        return <DummyRegisteredAgent {...this.props} />
      case 'FullName':
        return <DummyFullName {...this.props} />
      case 'NameOrg':
        return <DummyNameOrg {...this.props} />
      case 'NameQualifiedOrg':
        return <DummyNameQualifiedOrg {...this.props} />
      case 'Summary':
        return <Summary />
      case 'UploadAndSubmit':
        return <DummyUploadAndSubmit {...this.props} />
      case 'SearchControl':
        return <DummySearchControl {...this.props} />
      case 'Signatures':
        const label =
          this.props.fields[this.props.srcRepeater] && this.props.fields[this.props.srcField]
            ? this.props.fields[this.props.srcField].label
            : ''
        return <DummySignatures {...this.props} label={label} />
      case 'FormationLocale':
        return <DummyFormationLocale {...this.props} />
      case 'EntityNameSearch':
        return <DummyEntityName {...this.props} />
      case 'UCCSearch':
        return <DummyUCCSearch {...this.props} />
        case 'AltUCCSearch':
            return <DummyAltUCCSearch {...this.props} /> 
      case 'TimeInput':
        return <DummyTimeInput {...this.props} />
      case 'MultiComplete':
        return <DummyMultiComplete {...this.props} />
      case 'ServerMultiComplete':
        return <DummyMultiComplete {...this.props} />
      case 'EFSCropPicker':
        return <DummyEFSPicker {...this.props} />
      case 'LocalSelect':
        return <DummyLocalSelect {...this.props} />
      default:
    }
  }
  moveUp = () => {
    this.props.reorderField({ direction: 'up', fieldId: this.props.fieldId })
  }
  moveDown = () => {
    this.props.reorderField({ direction: 'down', fieldId: this.props.fieldId })
  }
  getAuditIcon = () => {
    const logs = this.props.auditLogs.filter(
      log =>
        log.entityMap.type !== 'STEP' &&
        log.entityMap.type !== 'SECTION' &&
        log.entityMap.fieldId === this.props.fieldId
    )
    const severity = getLogSeverity(logs)
    const logIcon = <LogIcon severity={severity} logs={logs} />
    let logBar = null
    if (severity > 5) {
      logBar = <div className="log-hint-bar" data-severity="error"></div>
    }
    if (severity === 4) {
      logBar = <div className="log-hint-bar" data-severity="warning"></div>
    }
    return {
      logIcon,
      logBar
    }
  }
  addFieldAbove = (fieldClass, properties) => {
    this.props.addFieldAbove(this.props.fieldId, this.props.sectionId, fieldClass, properties)
  }
  addFieldUnder = (fieldClass, properties) => {
    this.props.addFieldUnder(this.props.fieldId, this.props.sectionId, fieldClass, properties)
  }
  addSubField = (fieldClass, properties, direction = 'under') => {
    switch (this.props.subFieldType) {
      case 'OPTION':
        this.props.addOptionSubfield({
          fieldId: this.props.fieldId,
          optionIndex: this.props.optionIndex,
          fieldClass: fieldClass,
          properties: properties,
          direction
        })
        break
      case 'CHECK':
        this.props.addCheckSubfield({
          fieldId: this.props.fieldId,
          checkType: this.props.checkType,
          fieldClass: fieldClass,
          properties: properties,
          direction
        })
        break
      case 'REPEATER':
        this.props.addRepeaterSubfield({
          fieldId: this.props.fieldId,
          fieldClass: fieldClass,
          properties: properties,
          direction
        })
        break
      default:
    }
  }
  render() {
    const {
      required,
      label,
      description = '',
      hideLabel,
      isFirst,
      isLast,
      isNestedField,
      isSubField,
      selected,
      active,
      logicNodes,
      conditions
    } = this.props

    return (
      <DroppableFieldWrapper
        onAddFieldAboveRequested={
          isSubField
            ? (fieldClass, properties) => this.addSubField(fieldClass, properties, 'above')
            : this.addFieldAbove
        }
        onAddFieldUnderRequested={
          isSubField
            ? (fieldClass, properties) => this.addSubField(fieldClass, properties, 'under')
            : this.addFieldUnder
        }
        isFirst={isFirst}
      >
        <DumbField
          className={`${selected ? 'active' : ''}`}
          required={required}
          label={label}
          description={description}
          hideLabel={hideLabel}
          onClick={this.selectField}
          handleKeyDown={this.handleKeyDown}
          selected={selected}
          hasConditions={conditions ? conditions.length > 0 : false}
          hasLogic={Object.keys(logicNodes).length > 1}
          logIcon={this.getAuditIcon()}
          active={active}
        >
          {this.getFieldType()}
          {isFirst || isNestedField || !selected ? null : (
            <button title="move section up" className="reorder up" onClick={this.moveUp}>
              <CaretUpIcon />
            </button>
          )}
          {isLast || isNestedField || !selected ? null : (
            <button title="move section down" className="reorder down" onClick={this.moveDown}>
              <CaretDownIcon />
            </button>
          )}
        </DumbField>
      </DroppableFieldWrapper>
    )
  }
}
export default connect(
  (state, props) => ({
    selected: props.selected
      ? props.selected
      : state.designer.selected.type === 'FIELD' && state.designer.selected.id === props.fieldId,
    fields: state.designer.wizard.fields,
    auditLogs: state.designer.auditLogs
  }),
  {
    select,
    subSelect,
    reorderField,
    addFieldUnder,
    addFieldAbove,
    addOptionSubfield,
    addCheckSubfield,
    addRepeaterSubfield
  }
)(Field)

export const DumbField = ({
  children,
  required,
  label,
  description = '',
  className = '',
  onClick,
  handleKeyDown,
  hideLabel,
  attrIsHovered,
  active,
  selected,
  hasConditions,
  hasLogic,
  logIcon
}) => {
  const { state: dragState } = useDragStore()

  return (
    <div
      tabIndex="0" role="button" className={`dummy-field custom-focus ${className} ${attrIsHovered ? 'hovered' : ''} ${
        dragState.isDragging ? 'is-dragging' : ''
        }`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="audit-icon">{logIcon ? logIcon.logIcon : null}</div>
      {logIcon ? logIcon.logBar : null}
      {!hideLabel && label !== '' ? (
        <div>
          <label className={'field-label '}>
            <span className={'label-text ' + (required ? 'required' : '')}>{label}</span>
          </label>
          <span className="visually-hidden">Click to edit this field</span>
        </div>
      ) : null}
      {description !== '' && !hideLabel ? (
        <ReactMarkdown className="description" source={description} escapeHtml />
      ) : null}
      <div className="icons-wrapper">
        {active === false && <div className="designer-icon-wrapper"><InvisibleIcon className="icon" /></div>}
        {hasConditions === true && <div className="designer-icon-wrapper link-icon"><LinkIcon className="icon" /></div>}
        {hasLogic && <div className="designer-icon-wrapper logic-icon"><LogicSolidIcon className="icon" /></div>}
      </div>
      {active === false && <div className="inactive-shade" />}
      {children}
    </div>
  )
}

const DroppableFieldWrapper = ({
  children,
  isFirst,
  onAddFieldUnderRequested,
  onAddFieldAboveRequested
}) => {
  const { state: dragState } = useDragStore()
  const [isOver, setIsOver] = React.useState(false)
  const [isOverTop, setIsOvertop] = React.useState(false)

  const handleDragEnter = (_, accepted) => {
    if (accepted) {
      setIsOver(true)
    }
  }

  const handleDragLeave = (_, accepted) => {
    if (accepted) {
      setIsOver(false)
    }
  }

  const handleDragEnterUp = (_, accepted) => {
    if (accepted) {
      setIsOvertop(true)
    }
  }

  const handleDragLeaveUp = (_, accepted) => {
    if (accepted) {
      setIsOvertop(false)
    }
  }

  const handleDropAccepted = data => {
    var piece = Pieces.find(piece => piece.id === data)
    onAddFieldUnderRequested(piece.fieldClass, piece.properties)
    setIsOver(false)
  }

  const handleDropUpAccepted = data => {
    var piece = Pieces.find(piece => piece.id === data)
    onAddFieldAboveRequested(piece.fieldClass, piece.properties)
    setIsOver(false)
  }

  React.useEffect(() => {
    if (!dragState.isDragging) {
      if (isOver) setIsOver(false)
      if (isOverTop) setIsOvertop(false)
    }
  }, [dragState.isDragging])

  return (
    <Droppable
      className="droppable-field-wrapper"
      onDragEnter={handleDragEnter}
      onDragExit={handleDragLeave}
      onDropAccepted={handleDropAccepted}
      disabled={isFirst}
      accepts="field"
    >
      {isFirst && dragState.isDragging && (
        <Droppable
          onDragEnter={handleDragEnterUp}
          onDragExit={handleDragLeaveUp}
          onDropAccepted={handleDropUpAccepted}
          className="droppable-field-overlay up"
          accepts="field"
        />
      )}
      {isFirst && dragState.isDragging && (
        <div
          className={`field-drop-spacer ${
            isOverTop && dragState.isDragging ? 'is-over-spacer' : ''
            }`}
          style={{
            height: isOverTop && dragState.isDragging ? 60 : 0
          }}
        >
          <span className="drop-hint">Drop to add field</span>
        </div>
      )}
      {children}
      {dragState.isDragging && (
        <div
          className={`field-drop-spacer ${isOver && dragState.isDragging ? 'is-over-spacer' : ''}`}
          style={{
            height: isOver && dragState.isDragging ? 60 : 0
          }}
        >
          <span className="drop-hint">Drop to add field</span>
        </div>
      )}
      {isFirst && dragState.isDragging && (
        <Droppable
          onDragEnter={handleDragEnter}
          onDragExit={handleDragLeave}
          onDropAccepted={handleDropAccepted}
          className="droppable-field-overlay down"
          accepts="field"
        />
      )}
    </Droppable>
  )
}



// WEBPACK FOOTER //
// ./src/components/Designer2/Field.js